"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _utils = require("../../utils");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function parseDimensionValue(value) {
  if (value === null) {
    return 'auto';
  }

  if (value !== 0) {
    return "".concat(value, "px");
  }

  return value;
}

var useDropdown = function useDropdown(control, dimension) {
  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      preservedDimension = _useState2[0],
      setPreservedDimension = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      usedDimension = _useState4[0],
      setUsedDimension = _useState4[1];

  var dropdownRef = (0, _react.useRef)(null);
  var toggleDropdown = (0, _react.useCallback)(function (state) {
    return {
      enter: function enter() {
        usedDimension === 0 && setUsedDimension(preservedDimension);
        toggleDropdown('entered');
      },
      entered: function entered() {
        usedDimension !== null && usedDimension > 0 && (0, _utils.timeout)(300, function () {
          return setUsedDimension(null);
        });
      },
      exit: function exit() {
        usedDimension === null && setUsedDimension(preservedDimension);
        toggleDropdown('exited');
      },
      exited: function exited() {
        usedDimension !== null && usedDimension > 0 && (0, _utils.timeout)(preservedDimension / 4, function () {
          return setUsedDimension(0);
        });
      }
    }[state]();
  }, [usedDimension, preservedDimension]);
  (0, _react.useEffect)(function () {
    control ? toggleDropdown('enter') : toggleDropdown('exit');
  }, [control, usedDimension, preservedDimension, toggleDropdown]);
  (0, _react.useEffect)(function () {
    if (usedDimension === 0) {
      var _dropdownRef$current;

      setPreservedDimension(((_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.getBoundingClientRect()[dimension]) || 0);
    }
  }, [usedDimension]);
  return _defineProperty({
    ref: dropdownRef
  }, dimension, parseDimensionValue(usedDimension));
};

var _default = useDropdown;
exports["default"] = _default;